import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminExtraProductCategory,
  initializeRateAdminExtraProductCategoryScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminExtraProductCategory,
  saveExtraProductCategoryTableState
} from "../../../redux/actions/RateAdmin/rateadminExtraProductCategory";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import RateAdminExtraProductCategory from '../../../component/RateAdmin/RateAdminExtraProductCategory';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function RateAdminExtraProductCategoryScreen(props) {
  const {
    fetchRateAdminExtraProductCategory,
    initRateAdminExtraProductCategoryScreen,
    showPageLevelLoader,
    rateAdminExtraProductCategoryListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminExtraProductCategory,
    isRateAdminExtraProductCategoryExportError,
    isRateAdminExtraProductCategoryExportSuccess,
    isLoading,
    savedTableState,
    saveExtraProductCategoryTableState,
  } = props;
  const navigate = useNavigate();
  
  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initRateAdminExtraProductCategoryScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminExtraProductCategory(savedParams);
    } else {
      fetchRateAdminExtraProductCategory({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchRateAdminExtraProductCategory(props);
  };

  const handleTableStateChange = (tableState) => {
    saveExtraProductCategoryTableState(tableState);
  };

  const handleCreateRateAdminExtraProductCategory = () => {
    navigate(APP_URLS.RATEADMIN_EXTRAPRODUCTCATEGORY.CREATE);
  }
  const editRateAdminExtraProductCategoryRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_EXTRAPRODUCTCATEGORY.EDIT, {
      id,
    });
    navigate(path);
  };
  const rateAdminExtraProductCategory = {
    handleCreateRateAdminExtraProductCategory,
    exportRateAdminExtraProductCategory,
    isRateAdminExtraProductCategoryExportError,
    isRateAdminExtraProductCategoryExportSuccess,
    editRateAdminExtraProductCategoryRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchRateAdminExtraProductCategory: loadLazyData,
    tableData: {
      columns: rateAdminExtraProductCategoryListview?.columns,
      rows: rateAdminExtraProductCategoryListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminExtraProductCategory
        {...rateAdminExtraProductCategory}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminExtraProductCategoryScreen: () => dispatch(initializeRateAdminExtraProductCategoryScreen()),
    fetchRateAdminExtraProductCategory: (payload) => dispatch(fetchRateAdminExtraProductCategory(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminExtraProductCategory: (payload) => dispatch(exportRateAdminExtraProductCategory(payload)),
    saveExtraProductCategoryTableState: (payload) => dispatch(saveExtraProductCategoryTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminExtraProductCategoryCreateSuccess: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "isRateAdminExtraProductCategoryCreateSuccess"
    ),
    rateAdminExtraProductCategoryListview: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "rateAdminExtraProductCategoryListview"
    ),
    showPageLevelLoader: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminExtraProductCategoryExportError: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "isRateAdminExtraProductCategoryExportError"
    ),
    isRateAdminExtraProductCategoryExportSuccess: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "isRateAdminExtraProductCategoryExportSuccess"
    ),
    savedTableState: selectFromRateAdminExtraProductCategoryReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminExtraProductCategoryReducer = (state, path) => {
  return selectRateAdminExtraProductCategoryReducer(state)[path];
};

const selectRateAdminExtraProductCategoryReducer = ({ rateadminExtraProductCategoryReducer }) => {
  return rateadminExtraProductCategoryReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(RateAdminExtraProductCategoryScreen);
